import { render, staticRenderFns } from "./BtnCancelarIndicacao.vue?vue&type=template&id=383bed3c&"
import script from "./BtnCancelarIndicacao.vue?vue&type=script&lang=js&"
export * from "./BtnCancelarIndicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports